import { Pages } from '@/webiny/queries';
import { handleGetStaticProps } from '@/webiny/api';
import { fallbackData as fb } from './constants';

const { getHomePage } = Pages;

export const getStaticProps = handleGetStaticProps(getHomePage, fb);

export { default } from './Home';
